import { Navigate, createBrowserRouter } from "react-router-dom";
import type { RouteObject } from "react-router-dom";
import loadable from "@/components/loadable";
import routes from "./routes";
// import components from './components'
import { typeOf } from "@/utils";
import Layout from "@/components/layout";
import Error404 from "@/pages/404";

const menus = [...routes];

export function useMenus() {
  return menus;
}

export function createRoutes(routes: any[]) {
  const routerRoutes: RouteObject[] = [];
  for (const route of routes) {
    const element =
      typeOf(route.element) === "function"
        ? loadable(route.element,route.handle.isAuth)
        : route.element;
    const obj = { ...route, element };
    if (route.children && route.children.length > 0) {
      obj.children = createRoutes(route.children);
    }
    routerRoutes.push(obj);
  }
  return routerRoutes as RouteObject[];
}

export const useRouter = () => {
  return createBrowserRouter([
    {
      path: "/",
      Component: Layout,

      children: [
        {
          path: '',
          element: <Navigate replace to='/home' />
        },

        ...createRoutes(menus)
      ],
    },
    
    {
      path: "*",
      Component: Error404,
    },
  ]);
};

export default useRouter();
